var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"basket-payments-list"},_vm._l((_vm.list),function(item,index){return _c('li',{key:("basket-payments-list-" + index),staticClass:"basket-payments-list__item"},[_vm._v(" "+_vm._s(item)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }